export default __webpack_public_path__ + "static/media/employer_details_icon.8b6ef697.svg";